import Vue from 'vue'

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import { createPinia, PiniaVuePlugin } from 'pinia'

import i18n from '@/i18n/index'
import router from '@/router/index'
import App from './App.vue'

Vue.config.productionTip = false

Vue.use(ElementUI, { i18n: (key, val) => i18n.t(key, val) })
Vue.use(PiniaVuePlugin)

var pinia = createPinia()

new Vue({
  router,
  i18n,
  pinia,
  render: h => h(App),  
}).$mount('#app')
